import { SummarizerConfig } from '../../types/summarizer';
import TextSummarizerLayout from '@components/summarizer/custom/text-summarizer/TextSummarizerLayout';
import TextSummarizerInput from '@components/summarizer/custom/text-summarizer/TextSummarizerInput';
import TextSummarizerOutput from '@components/summarizer/custom/text-summarizer/TextSummarizerOutput';

export const textSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'text-summarizer',
  title: 'Instant Text Summarizer with AI',
  description: 'Get quick summaries in any language.',
  version: '1.0.0',

  // Categorization
  category: 'document',
  tags: ['text', 'content', 'article', 'instant'],

  // Input configuration
  inputs: {
    file: {
      enabled: false, // Will be handled via Upload Doc button in custom component
    },
    url: {
      enabled: false, // Text summarizer focuses on direct text input
    },
    text: {
      enabled: true,
      placeholder: 'Enter or paste your text',
      maxLength: 50000,
      minLength: 50,
      rows: 10,
      helpText: 'Paste any text content to get instant AI-powered summaries with customizable length and tone.',
      showHelpText: false, // Custom component handles its own help
    },
  },

  // Output features
  outputs: {
    summary: true,
    chat: true,
    repurpose: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: false, // Not applicable for text
    download: true,
    share: true,
  },

  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'text',
    timeout: 30000, // 30 seconds for text processing
  },

  // UI customization
  ui: {
    primaryColor: '#3b82f6', // Blue
    secondaryColor: '#1d4ed8',
    icon: '📝',
    theme: 'light',
    // Custom loading messages for text content
    loadingMessages: {
      aiGeneration: {
        title: 'AI is analyzing your text...',
        subtitle: 'Processing your content and extracting key insights for summary.',
      },
      translation: {
        title: 'Translating text summary to {language}...',
        subtitle: 'Converting your text summary to the selected language.',
      },
      streaming: {
        indicator: 'Generating text insights...',
      },
    },
    // Custom components for text-specific design
    customComponents: {
      layout: TextSummarizerLayout,
      input: TextSummarizerInput,
      output: TextSummarizerOutput as any,
    },
  },

  // Validation rules
  validation: {
    required: true,
    minSize: 50,
    maxSize: 50000,
    allowedDomains: [],
    blockedDomains: [],
  },

  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false,
  },

  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01',
};
